import { defineMessages } from "react-intl";

export const enumOptionsMessages = defineMessages({
  displayModeSidebar: { id: "orchestrator.enum.displayMode.sidebar", defaultMessage: "Sidebar" },
  displayModeExtended: { id: "orchestrator.enum.displayMode.extended", defaultMessage: "Extended" },
  resultsFormatAuto: { id: "orchestrator.enum.resultsFormat.auto", defaultMessage: "Auto" },
  resultsFormatGrid: { id: "orchestrator.enum.resultsFormat.grid", defaultMessage: "Grid" },
  resultsFormatList: { id: "orchestrator.enum.resultsFormat.list", defaultMessage: "List" },
  resultsFormatUnified: {
    id: "orchestrator.enum.resultsFormat.unified",
    defaultMessage: "Unified",
  },
  accommodationsOrderAscending: {
    id: "orchestrator.enum.accommodationsOrder.ascending",
    defaultMessage: "Ascending Price",
  },
  accommodationsOrderDescending: {
    id: "orchestrator.enum.accommodationsOrder.descending",
    defaultMessage: "Descending Price",
  },
  accommodationsOrderNoSorting: {
    id: "orchestrator.enum.accommodationsOrder.noSorting",
    defaultMessage: "List Position (No Sorting)",
  },
  bookingAdvantagesTop: { id: "orchestrator.enum.bookingAdvantages.top", defaultMessage: "Top" },
  bookingAdvantagesBottom: {
    id: "orchestrator.enum.bookingAdvantages.bottom",
    defaultMessage: "Bottom",
  },
  servicesExpanded: {
    id: "orchestrator.enum.services.expanded",
    defaultMessage: "Show Extras Before Checkout",
  },
  servicesExpandedDesktop: {
    id: "orchestrator.enum.services.expandedDesktop",
    defaultMessage: "Show Extras Before Checkout (Desktop)",
  },
  servicesCollapsed: {
    id: "orchestrator.enum.services.collapsed",
    defaultMessage: "Hide Extras Before Checkout",
  },
  priceCalendarShowAll: {
    id: "orchestrator.enum.priceCalendar.showAll",
    defaultMessage: "Show All Prices",
  },
  priceCalendarShowSelected: {
    id: "orchestrator.enum.priceCalendar.showSelected",
    defaultMessage: "Show Selected Date Prices",
  },
  priceCalendarHideAll: {
    id: "orchestrator.enum.priceCalendar.hideAll",
    defaultMessage: "Hide All Prices",
  },
  bookAndJoinDisabled: { id: "orchestrator.enum.bookAndJoin.disabled", defaultMessage: "Disabled" },
  bookAndJoinOptIn: { id: "orchestrator.enum.bookAndJoin.optIn", defaultMessage: "Opt-In" },
  bookAndJoinOptOut: { id: "orchestrator.enum.bookAndJoin.optOut", defaultMessage: "Opt-Out" },
  roundTypeZero: { id: "orchestrator.enum.roundType.zero", defaultMessage: "Zero ({value})" },
  roundTypeDefault: {
    id: "orchestrator.enum.roundType.default",
    defaultMessage: "Default ({value})",
  },
  roundTypeMd: { id: "orchestrator.enum.roundType.md", defaultMessage: "MD ({value})" },
  roundTypeLg: { id: "orchestrator.enum.roundType.lg", defaultMessage: "LG ({value})" },
  roundTypeXl: { id: "orchestrator.enum.roundType.xl", defaultMessage: "XL ({value})" },
  roundTypeXxl: { id: "orchestrator.enum.roundType.xxl", defaultMessage: "XXL ({value})" },
  roundTypeXxxl: { id: "orchestrator.enum.roundType.xxxl", defaultMessage: "XXXL ({value})" },
  roundTypeFull: { id: "orchestrator.enum.roundType.full", defaultMessage: "Full ({value})" },
});
